import { SolidityValues, SolidityResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

export function calculateSolidity(values: SolidityValues, t?: ToolsTranslations['solidity']): SolidityResult {
  const { equity, totalAssets } = values;

  if (equity < 0) {
    return { solidityPercent: null, isValid: false, message: t?.invalid.equity ?? 'Eget kapital måste vara 0 eller mer' };
  }
  if (totalAssets <= 0) {
    return { solidityPercent: null, isValid: false, message: t?.invalid.totalAssets ?? 'Tillgångar måste vara större än 0' };
  }

  const solidity = (equity / totalAssets) * 100;
  const solidityPercent = Math.round(solidity * 100) / 100; // 2 decimals

  if (!isFinite(solidityPercent)) {
    return { solidityPercent: null, isValid: false, message: t?.invalid.generic ?? 'Ogiltiga värden' };
  }

  return { solidityPercent, isValid: true };
}


